import { IProductGetRequest, IProductPatchRequest } from "interfaces/IProduct"
import { api as apiService, ApiService } from "./api"

export interface ProductBasePopup {
  id: number
  created: string
  updated: string
  productId: number | null
  sku: string | null
  purchaseValue: number | null
  portionType: string | null
  separationOrder: number | null
  name: string
  status: string
  productBaseId: number
}

interface ProductBaseResponse {
  totalCount: number
  pageIndex: number
  pageSize: number
  results: ProductBasePopup[]
}

interface BatchCheckResponse {
  batch_id: number
  skuData: {
    productId: number
    sku: string
    purchaseValue: number
    portionType: string
    separationOrder: number
    name: string
    productBaseId: number
  }
}

class ProductService {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  public getProducts = async (params: IProductGetRequest) => {
    return await this.api.get(toranjaURL + "/product-cache/", { params })
  }

  public checkBatch = async (codeLabel: string, sku: string): Promise<BatchCheckResponse> => {
    return await this.api.get(toranjaURL + "/batch/check", {
      params: { codeLabel, sku },
    })
  }

  public patchProduct = async (data: IProductPatchRequest, productId: number) => {
    return await this.api.patch(toranjaURL + `/product-cache/${productId}`, data)
  }

  public patchUploadExcelProduct = async (data: any, filename: string) => {
    return await this.api.patch(toranjaURL + `/product-cache/product/upload/${filename}`, data)
  }

  public getProductBases = async (
    searchTerm?: string,
    pageSize?: number,
  ): Promise<ProductBaseResponse> => {
    const response = await this.api.get(`${toranjaURL}/product-cache/product-base`, {
      params: {
        productBaseName: searchTerm,
        pageSize,
      },
    })
    return response
  }
}

const toranjaURL = process.env.REACT_APP_TORANJA_API
export const productService = new ProductService(apiService)
